/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('finance.vckkcat')
    .component('kkcatform', {
      restrict: 'E',
      bindings: {
        kkcat: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcfinance/kkcat/kkcatform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          // vm.zipsave = zipsave;
          
          vm.$onInit = function () {
            vm.lastkkcat = angular.copy(vm.kkcat);
          };
          
          function save() {
            if (!angular.equals(vm.kkcat, vm.lastkkcat)) {
              vm.lastkkcat = angular.copy(vm.kkcat);
              vm.parentsave({kkcat: vm.kkcat});
            }
          }
          
          function cancel() {
            vm.kkcat = angular.copy(vm.lastkkcat);
            vm.oncancel();
          }
          
/*          function zipsave (zip, city) {
            $log.debug('debug: kkcatform zipsave called: ', zip, city);
            // vm.kkcat.postcode = zip;
            // vm.kkcat.city = city;
          }*/
          
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());